import React from "react";

export default function PhoneCodeComponentMini({ flag, dialCode, name }: any) {
  return (
    <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
      <span
        style={{
          backgroundImage: `url("${flag}")`,
          width: "20px",
          height: "20px",
          backgroundPosition: "center",
          backgroundSize: "cover",
          borderRadius: "50%",
          backgroundRepeat: "no-repeat",
        }}
      />
      <span className="text-white-color">{dialCode}</span>
      {name && <span className="text-white-color">{name}</span>}
    </span>
  );
}
